import React, {useState, useEffect} from "react";

import {
    formatDate,
} from "../prodect/ProsCommonUi";
import {
    getActiveProject,
    getActiveMainProjectName,
    getActiveSubProjectName,
    getActiveProjectsCustomerId,
    ATTR_OBJ_ID,
    ATTR_TEXT, ATTR_LOGO_FILE_NAME, STR_NO_VALUE, ATTR_CUSTOMER_NAME,
    ATTR_UPDATED_MS_I,
    ATTR_UPDATED_BY,
    OBJ_TYPE_PDF_FRONTPAGE,
    getLogoThumpPath,
    getProjectSharedReports,
    getCustomerConfigs,
} from "../prodect/ProsConnect";
import Checkbox from "../components/Checkbox";
import BasicButton, {CancelButton, ConfirmButton} from "../components/BasicButton";
import AccordionDropdown from "../components/AccordionDropdown";
import DropdownMenu from "../components/DropdownMenu";
import TextInput from "../components/TextInput";
import Spacer from "../components/Spacer";
import UiImage from "../components/UiImage";

const textStyleToLabelMap = {
    pageHeader1: {label: "H1 Otsikko", placeholder: "Etusivun otsikko", maxRows: null, class: "pdf-preview-header1", element: 'h1'},
    bottomLineHeader2: {label: "H2 Otsikko", placeholder: "Väliotsikko", maxRows: null, class: "pdf-preview-header2", element: 'h2'},
    bottomLineHeader3: {label: "H3 Otsikko", placeholder: "Väliotsikko", maxRows: null, class: "pdf-preview-header3", element: 'h3'},
    paragraph: {label: "Leipäteksti", placeholder: "Leipäteksti", maxRows: 3, class: "pdf-preview-paragraph", element: 'p'},
    paragraphSmall: {label: "Pieni leipäteksti", placeholder: "Pieni leipäteksti", maxRows: 3, class: "pdf-preview-paragraph-small", element: 'p'},
    pageBreak: {label: "Sivunvaihto", placeholder: "Sivunvaihto", maxRows: null, class: "pdf-preview-pagebreak", element: 'p'},
}

const MAX_NUMBER_OF_SENT_REPORTS_SELECTABLE = 50;
const SESSION_PDF_COVER_PAGE_ITEMS = "sessionPdfCoverPageItems";
const SESSION_PDF_PAGE_HEADER = "sessionPdfPageHeaderText";
const SESSION_PDF_PAGE_FOOTER = "sessionPdfPageFooterText";
const LOCAL_STORAGE_SHOW_USER_INFO = "localPdfReportOptionsShowUserInfo";

export default function PdfReportOptions({title, closeCallback, setOptionsCallback, showingSearchList, defaultShowComments, 
    defaultShowPictures, defaultPdfCoverPageItems, defaultPdfCoverPageTemplateName,
    defaultIsCoverPageEnabled, isTemplateEditorMode}) {

    const [pdfShowComments, setPdfShowComments] = useState(defaultShowComments);
    const [pdfShowPictures, setPdfShowPictures] = useState(defaultShowPictures);
    const [pdfShowItemUserInfo, setPdfShowItemUserInfo] = useState(() => {
        // Read at initial render the value from local storage
        const localData = localStorage.getItem(LOCAL_STORAGE_SHOW_USER_INFO);
        return localData ? JSON.parse(localData) : true
    });
    const [pdfPageHeaderText, setPdfPageHeaderText] = useState(null)
    const [pdfPageFooterText, setPdfPageFooterText] = useState(null)
    const [pdfCoverPageTemplateName, setPdfCoverPageTemplateName] = useState(defaultPdfCoverPageTemplateName || "Pohjan nimi")
    const [pdfCoverPageEnabled, setPdfCoverPageEnabled] = useState(defaultIsCoverPageEnabled || false)
    const [pdfCoverPageItems, setPdfCoverPageItems] = useState(defaultPdfCoverPageItems || []) // item = {text: "", style: ""}
    const [pdfCoverPageSelectItemType, setPdfCoverPageSelectItemType] = useState(-1)
    const [pdfCoverPageHistory, setPdfCoverPageHistory] = useState([])
    const [pdfCoverPageCustomerTemplates, setPdfCoverPageCustomerTemplates] = useState([])
    const [selectedCustomerTemplate, setSelectedCustomerTemplate] = useState(null)
    const [selectedHistoryItem, setSelectedHistoryItem] = useState(null)
    const [activeDragAndDrop, setActiveDragAndDrop] = useState(false)
    const [dragId, setDragId] = useState()

    // Note: when isTemplateEditorMode is null/undefined, user is sharing PDF report and edits PDF options including PDF frontpage prior to sharing report. 
    //       Otherwise, this component is used as editor to create/edit PDF cover page templates and save them to customer config

    useEffect(() => {
        if(!isTemplateEditorMode) {
            // If PDF options used from share report, we are history of cover pages available
            let coverPageHistoryList = getProjectSharedReports(getActiveProject(), true).map(item => {
                return {"ui_date": formatDate(item[ATTR_UPDATED_MS_I], true), ...item}
            });
            coverPageHistoryList = coverPageHistoryList.slice(0, MAX_NUMBER_OF_SENT_REPORTS_SELECTABLE);
            setPdfCoverPageHistory(coverPageHistoryList);

            const getCustomerPdfFrontpages = async () => {
                const configs = await getCustomerConfigs(getActiveProjectsCustomerId(), OBJ_TYPE_PDF_FRONTPAGE);
                setPdfCoverPageCustomerTemplates(configs);
            };

            getCustomerPdfFrontpages();

            const sessionItems = sessionStorage.getItem(SESSION_PDF_COVER_PAGE_ITEMS);
            if(sessionItems){
                setPdfCoverPageItems(JSON.parse(sessionItems));
            }
            const sessionPageHeader = sessionStorage.getItem(SESSION_PDF_PAGE_HEADER);
            if(sessionPageHeader != null){
                setPdfPageHeaderText(sessionPageHeader);
            }
            const sessionPageFooter = sessionStorage.getItem(SESSION_PDF_PAGE_FOOTER);
            if(sessionPageFooter){
                setPdfPageFooterText(sessionPageFooter);
            }
        }
    }, [isTemplateEditorMode]); // empty list: [] => run only at first render

    useEffect(() => {
        if(!isTemplateEditorMode){
            sessionStorage.setItem(SESSION_PDF_COVER_PAGE_ITEMS, JSON.stringify(pdfCoverPageItems));
        }
    }, [isTemplateEditorMode, pdfCoverPageItems]);

    useEffect(() => {
        if(!isTemplateEditorMode && pdfPageHeaderText != null){
            sessionStorage.setItem(SESSION_PDF_PAGE_HEADER, pdfPageHeaderText);
        }
    }, [isTemplateEditorMode, pdfPageHeaderText]);

    useEffect(() => {
        if(!isTemplateEditorMode && pdfPageFooterText != null){
            sessionStorage.setItem(SESSION_PDF_PAGE_FOOTER, pdfPageFooterText);
        }
    }, [isTemplateEditorMode, pdfPageFooterText]);

    // useEffect(() => {
    //     setPdfCoverPageTemplateName(defaultPdfCoverPageTemplateName)
    // }, [defaultPdfCoverPageTemplateName])

    const addPdfTextItem = (style) => {
        const nextId = pdfCoverPageItems.length > 0
            ? Math.max(...pdfCoverPageItems.map(it => it.id)) + 1
            : 0;
        const nextIndex = pdfCoverPageItems.length;
        setPdfCoverPageItems(pdfCoverPageItems.concat([{
            id: nextId,
            order: nextIndex,
            text: "", 
            style,
        }]));
    }

    const removePdfTextItem = (textItem) => {
        const newItems = pdfCoverPageItems;
        newItems.splice(textItem.order, 1);
        const newAfterDeleteItems = newItems.map((itm, index) => ({...itm, order: index}));
        setPdfCoverPageItems(newAfterDeleteItems);
    }

    const changePdfTextItemText = (textItem, val) => {
        const item = pdfCoverPageItems.find(it => it.id === textItem.id)
        if(!item){
            return;
        }
        const newItems = pdfCoverPageItems;
        newItems[item.order].text = val
        setPdfCoverPageItems([...newItems]);
    }

    const changePdfTextItemStyle =(textItem, val)=> {
        const item = pdfCoverPageItems.find(it => it.id === textItem.id)
        if(!item){
            return
        }
        const newItems = pdfCoverPageItems
        newItems[item.order].style = val
        setPdfCoverPageItems([...newItems])
    }

    const handleDrag = (ev) =>  {
        setDragId(ev.currentTarget.id);
    }

    const moveInArray = (arr, from, to) => {

        // Make sure a valid array is provided
        if (Object.prototype.toString.call(arr) !== '[object Array]') {
            throw new Error('Please provide a valid array');
        }
    
        // Delete the item from it's current position
        var item = arr.splice(from, 1);
    
        // Move the item to its new position
        arr.splice(to, 0, item[0]);
        return arr;
    }

    const handleDrop = (ev) => {
        const dragItem = pdfCoverPageItems.find((itm) => itm.id === parseInt(dragId));
        const dropItem = pdfCoverPageItems.find((itm) => itm.id === parseInt(ev.currentTarget.id));

        // Sort order by drag and drop
        let editItems = moveInArray(pdfCoverPageItems, dragItem.order, dropItem.order);
        const newPdfCoverPageItems = editItems.map((itm, index) => ({...itm, order: index}));
        setPdfCoverPageItems(newPdfCoverPageItems);
        setActiveDragAndDrop(false)
    };

    const renderPagePreview = () => {
        let chunkIndex = 0;
        const pageChunks = [];
        pageChunks[chunkIndex] = [];
        pdfCoverPageItems.forEach(item => {
            if(item.style === "pageBreak") {
                chunkIndex++;
                pageChunks[chunkIndex] = []; // start a new chunk
            }
            pageChunks[chunkIndex].push(item);
        });

        return pageChunks.map((pageItems, index) => {
            return (<div className={"pdf-preview-page"} key={`pdf-preview-${index}`} >
                <header className={"element-set-sm"}>
                    <div className={"element-set-sm"}>
                        {logoFileName !== STR_NO_VALUE ? <UiImage
                                imageId={"pdf-preview-logo"}
                                imageSrc={getLogoThumpPath(logoFileName)}
                                alt={project.attrs[ATTR_CUSTOMER_NAME] || 'logo'}
                            /> : null}
                        <div className={"element-set-v-sm"}>
                            <h3>{`${getActiveMainProjectName()}/${getActiveSubProjectName()}`}</h3>
                            <p>{reportName}</p>
                        </div>
                    </div>
                    <div className={"flex-grow element-set"}>
                        {pdfPageHeaderText ? <p className={"flex-grow text-center"}>{pdfPageHeaderText}</p> : null}
                        <div className={"element-set-v-sm"}>
                            <img src={"./images/prodect-text.svg"} alt=""/>
                            <p>www.prodect.com</p>
                        </div>
                    </div>
                </header>
                <section>
                        {pageItems.map((it) => renderTextPreview(it))}
                </section>
                <footer>
                    <div>
                        <p>{`Tiedot päivitetty ${dateTime}`}</p>
                    </div>
                    <div className={"text-center"}>
                        {pdfPageFooterText ? <p>{pdfPageFooterText}</p> : null}
                        <div className={"text-center"}>
                            <p>{(index + 1) + '/' + pageChunks.length}</p>
                        </div>
                    </div>
                    <div>
                        <p>{`Prodect ${dateTime}`}</p>
                    </div>
                </footer>
            </div>)
        })
    }

    const renderTextPreview = (textItem) => {
        const className = textItem.style
            ? textStyleToLabelMap[textItem.style].class
            : ""
        const CustomTag = textItem.style ?  textStyleToLabelMap[textItem.style].element : 'div'
        if (CustomTag === 'hr'){
            return <CustomTag/>
        }
        const textList = textItem.text.split(/\r?\n/);
        return textList.map((text, index) => <CustomTag
            id={`pdf-preview-${textItem.id}-${index}`}
            key={`pdf-preview-${textItem.id}-${index}`}
            className={className}>
                {text}
        </CustomTag>)
    }

    const renderTextItem =(textItem)=> {
        const item = textItem
        let label = null
        let placeholder = null
        if(item.style){
            label = textStyleToLabelMap[item.style].label
            placeholder = textStyleToLabelMap[item.style].placeholder
        }
        let textItemOptions = Object.keys(textStyleToLabelMap).map(key => {
            return {
                value: key,
                text: textStyleToLabelMap[key].label,
                selected: item.style === textStyleToLabelMap[key].style,
                action: ()=>{
                    changePdfTextItemStyle(item, key)
                }
            }
        })
        textItemOptions.push({
            value: 12345678,
            text: 'Poista',
            action: () => removePdfTextItem(item),
            icon: 'delete'
        })

        return <div
            id={item.id}
            key={`pdf-text-item-${item.id}-${item.order}`}
            draggable={activeDragAndDrop}
            onDrop={handleDrop}
            onDragOver={(ev) => ev.preventDefault()}
            onDrag={handleDrag}
            className={"element-set-sm"}
        >
            {item.style === "pageBreak"
                ? <Spacer line label={label}/>
                : <TextInput
                    label={label}
                    value={item.text}
                    placeholder={placeholder || "Kirjoita teksti..."}
                    multiline={textStyleToLabelMap[item.style].maxRows}
                    onChange={(val)=>{
                        changePdfTextItemText(item, val)
                    }}
                />}
            <BasicButton
                icon={"drag-v"}
                onMouseDown={()=>{
                    setActiveDragAndDrop(true)
                }}
                disabled={pdfCoverPageItems.length < 2}
            />
            <DropdownMenu
                values={textItemOptions}
                icon={"ellipsis-v"}
                hideArrow
                text={false}
                btnClass={"3rd"}
                className={"ui-dropdown-center ui-dropdown-align-right"}
            />
        </div>
    }

    const isTemplateValid =()=>{
        if(!pdfCoverPageEnabled) return true
        const valid = pdfCoverPageTemplateName && pdfCoverPageTemplateName.length > 0 && pdfCoverPageItems.length > 0
        return valid
    }

    function renderDropdowns(){
        return <>
            {pdfCoverPageHistory.length > 0 ? <>
                    <Spacer size={"xl"} />
                    <DropdownMenu
                        text={"Valitse pohja lähetetyistä"}
                        values={pdfCoverPageHistory.map(sentItem => {
                            return {
                                value: sentItem[ATTR_OBJ_ID],
                                text: `${sentItem.ui_reportName} - ${sentItem.ui_date}`
                            }
                        })}
                        currentValue={selectedHistoryItem}
                        onSelect={(val)=>{
                            if(val !== -1) {
                                setSelectedHistoryItem(val);
                                const selectedHistoryItem = pdfCoverPageHistory.find(it => it[ATTR_OBJ_ID] === val);
                                setPdfCoverPageItems(selectedHistoryItem.report_req_obj.coverPage.content);
                            }
                        }}
                        className={"ui-dropdown-align-right width-100_md"}
                    />
                </> : null}

            {pdfCoverPageCustomerTemplates.length > 0 ? <>
                    <Spacer size={"lg"} />
                    <DropdownMenu
                        text={"Valitse pohja asiakaskohtaisista PDF-etusivuista"}
                        values={pdfCoverPageCustomerTemplates.map(templItem => {
                            return {
                                value: templItem[ATTR_OBJ_ID],
                                text: `${templItem[ATTR_TEXT]} - ${templItem[ATTR_UPDATED_BY]} ${formatDate(templItem[ATTR_UPDATED_MS_I], true)}`
                            }
                        })}
                        currentValue={selectedCustomerTemplate}
                        onSelect={(val)=>{
                            if(val !== -1) {
                                setSelectedCustomerTemplate(val);
                                const selectedItem = pdfCoverPageCustomerTemplates.find(it => it[ATTR_OBJ_ID] === val);
                                setPdfCoverPageItems(selectedItem.content);
                            }
                        }}
                        className={"ui-dropdown-align-right width-100_md"}
                    />
                    <Spacer label={!selectedCustomerTemplate && !selectedHistoryItem ? "Tai luo uusi" : "Rakenna etusivupohjasta"} line size={"xl"} />
                </> : null}
        </>
    }

    /*
        H1 with body:
          {text: "Otsikko1", style: "pageHeader1"}
          {text: "leipäteksti", style: "paragraph", "rows": 6}

        ------------------------
        This goes to the server:
        ------------------------
        coverPage: {
            content: [
                {text: "", style: "pageHeader1", "rows": 1},
                {text: "", style: "bottomLineHeader2", "rows": 1},
                {text: "", style: "bottomLineHeader2", "rows": 1},
                {text: "", style: "paragraph", "rows": 6},
                {text: "", style: "paragraphSmall", "rows": 6},
            ]
        }
    */
    const dateTime = formatDate(Date.now());
    const project = getActiveProject();
    const selectedSearch = showingSearchList ? project.getSelectedSearch() : undefined
    const reportName = selectedSearch ? selectedSearch[ATTR_TEXT] : `PDF-${dateTime}`;
    const logoFileName = (project && project.attrs[ATTR_LOGO_FILE_NAME]) || STR_NO_VALUE
    return <>
        <div className={"popup-pdf-share" + (pdfCoverPageEnabled ? " display-flex flex-wrap" : "")}>
            <div>
                {!isTemplateEditorMode && <div className={"selection-group selection-group-check"}>
                    <Checkbox
                        text={"Näytä kommentit"}
                        checked={pdfShowComments}
                        disabled={false}
                        onChange={() => {
                            setPdfShowComments(!pdfShowComments);
                        }}
                    />
                    <Checkbox
                        text={"Näytä kuvat ja videot"}
                        checked={pdfShowPictures}
                        disabled={false}
                        onChange={() => {
                            setPdfShowPictures(!pdfShowPictures);
                        }}
                    />
                    <Checkbox
                        text={"Näytä tekijä ja luontihetki"}
                        checked={pdfShowItemUserInfo}
                        disabled={false}
                        onChange={() => {
                            const newPdfShowItemUserInfo = !pdfShowItemUserInfo;
                            localStorage.setItem(LOCAL_STORAGE_SHOW_USER_INFO, JSON.stringify(newPdfShowItemUserInfo))
                            setPdfShowItemUserInfo(newPdfShowItemUserInfo);
                        }}
                    />
                </div>}

                {!isTemplateEditorMode && <>
                    <TextInput
                        label={"Ylätunniste"}
                        placeholder={"Kirjoita teksti..."}
                        info={"Teksti, joka toistuu sivujen yläosassa"}
                        value={pdfPageHeaderText}
                        onChange={(val)=>{
                            setPdfPageHeaderText(val)
                        }}
                    />
                    <Spacer/>
                </>}

                {isTemplateEditorMode && <>
                    <TextInput
                        label={"PDF-etusivupohjan nimi"}
                        placeholder={"Kirjoita nimi..."}
                        value={pdfCoverPageTemplateName}
                        onChange={(val)=>{
                            setPdfCoverPageTemplateName(val)
                        }}
                        isControlled
                        required
                        isValid={isTemplateValid()}
                        info={"Pohjan nimi ei näy tulosteessa"}
                    />
                    <Spacer/>
                </>}
                <AccordionDropdown key={'accordion__pdfOptions'} header={<h3>Lisää etusivu</h3>}
                    callback={()=>{
                        setPdfCoverPageEnabled(!pdfCoverPageEnabled);
                        setPdfCoverPageSelectItemType(-1);
                    }}
                    initiallyOpen={isTemplateEditorMode}
                >
                    {!isTemplateEditorMode && pdfCoverPageItems.length === 0 ? renderDropdowns() : null}
                    {pdfCoverPageItems.map((it) => renderTextItem(it))}
                    <div className={"btn-set width-100_lg"}>
                        <DropdownMenu
                            icon={"plus"}
                            values={Object.keys(textStyleToLabelMap).map(key => {
                                return {
                                    value: key, 
                                    text: textStyleToLabelMap[key].label
                                }
                            })}
                            currentValue={pdfCoverPageSelectItemType}
                            onSelect={(val)=>{
                                setPdfCoverPageSelectItemType(val)
                                if(val !== -1) {
                                    addPdfTextItem(val)
                                }
                            }}
                            emptyValue={pdfCoverPageSelectItemType === -1 ? {
                                value: -1,
                                text: 'Lisää otsikko tai teksti'
                            } : null}
                            className={"ui-dropdown-center"}
                        />
                        <BasicButton
                            btnClass={"2nd"}
                            icon={"delete"}
                            label={"Tyhjennä etusivu"}
                            action={()=>{
                                setPdfCoverPageSelectItemType(-1)
                                setPdfCoverPageItems([])
                                setSelectedHistoryItem(null);
                                setSelectedCustomerTemplate(null);
                            }}
                            disabled={pdfCoverPageItems.length < 1}
                            shrink={"md"}
                        />
                    </div>
                </AccordionDropdown>
                <Spacer/>
                {!isTemplateEditorMode && <TextInput
                    label={"Alatunniste"}
                    placeholder={"Kirjoita teksti..."}
                    value={pdfPageFooterText}
                    onChange={(val)=>{
                        setPdfPageFooterText(val)
                    }}
                    info={"Teksti, joka toistuu sivujen alaosassa"}
                />}
            </div>
            {pdfCoverPageEnabled
                ? <div className={"element-set-v"}>{renderPagePreview()}</div>
                : null }
        </div>
        <footer className={"popup-footer margin-top"}>
            <div className={"btn-set"}>
                <CancelButton
                    action={closeCallback}
                />
                <ConfirmButton
                    label={title}
                    action={()=> {
                        let data = {
                            showComments: pdfShowComments,
                            showPictures: pdfShowPictures,
                            showItemUserInfo: pdfShowItemUserInfo,
                            reportUserTitle: pdfPageHeaderText,
                            reportUserFooter: pdfPageFooterText,
                            coverPageEnabled: pdfCoverPageEnabled,
                            coverPageTemplateName: pdfCoverPageTemplateName,
                            coverPage: {
                                content: pdfCoverPageItems
                            }
                        }
                        if(!isTemplateEditorMode){
                            // If PDF options used from share report, we have these 3 extra information
                            data = {
                                ...data,
                                showComments: pdfShowComments,
                                showPictures: pdfShowPictures,
                                showItemUserInfo: pdfShowItemUserInfo,
                            }
                            // Also session storage holds done changes only when using PDF editor from share-report
                            sessionStorage.removeItem(SESSION_PDF_COVER_PAGE_ITEMS)
                            sessionStorage.removeItem(SESSION_PDF_PAGE_HEADER)
                            sessionStorage.removeItem(SESSION_PDF_PAGE_FOOTER)
                        }
                        setOptionsCallback(data)
                    }}
                    disabled={!isTemplateValid()}
                />
            </div>
        </footer>
    </>
}